module.exports = React;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 18
// module chunks = 0 1 2 3 4